"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Separator } from "@/components/ui/separator";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function AboutMe() {
  const {
    ref: imageRef,
    isVisible: isImageVisible
  } = useRevealOnScroll({
    threshold: 0.1,
    rootMargin: "0px 0px -50px 0px"
  });
  const {
    ref: contentRef,
    isVisible: isContentVisible
  } = useRevealOnScroll({
    threshold: 0.1,
    rootMargin: "0px 0px -50px 0px"
  });
  return <section data-section-id="154377" id="ayricalikligulustasarimideneyimi" className="relative w-full bg-background text-foreground py-24 md:py-32 overflow-hidden">
      <div className="container mx-auto px-6 md:px-8 max-w-7xl">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          
          {}
          <div ref={imageRef} className={`lg:col-span-5 lg:col-start-1 relative transition-all duration-1000 ease-out ${isImageVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
            <div className="relative group overflow-hidden rounded-none shadow-xl">
              <AspectRatio ratio={3 / 4} className="bg-muted/50 backdrop-blur-md">
                <img src="https://dtaysegul.10web.cloud/wp-content/uploads/2026/04/IMG_5153-1-scaled.jpg" alt="Diş Hekimi Ayşegül İnneci Uzun" className="object-cover w-full h-full opacity-95 transition-transform duration-1000 group-hover:scale-105" />
                {}
                <div className="absolute inset-0 bg-gradient-to-t from-background/60 via-transparent to-transparent backdrop-blur-[1px] mix-blend-normal" />
              </AspectRatio>
              
              {}
              <div className="absolute top-0 left-0 w-8 h-8 border-t border-l border-[var(--primary)] opacity-60 m-4" />
              <div className="absolute bottom-0 right-0 w-8 h-8 border-b border-r border-[var(--primary)] opacity-60 m-4" />
            </div>
          </div>

          {}
          <div ref={contentRef} className={`lg:col-span-6 lg:col-start-7 flex flex-col justify-center transition-all duration-1000 delay-200 ease-out ${isContentVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
            <h2 className="font-serif text-4xl leading-tight tracking-widest text-foreground !w-[700px] md:text-5xl lg:text-6xl">Kayseri<br /><font color="#baa05e"><i>Zirkonyum Tedavisi</i></font></h2>
            
            <Separator className="w-16 h-[1px] bg-[var(--primary)] my-8" />
            
            <div className="font-sans text-sm md:text-base leading-relaxed text-muted-foreground space-y-6">
              <p>&nbsp; Kayseri’de zirkonyum kaplama tedavisi, estetik ve dayanıklılığı bir arada sunan en modern diş hekimliği uygulamalarından biridir. Diş Hekimi Ayşegül İnneci Uzun Kliniği olarak, dijital ölçüm sistemleri ve kişiye özel planlama ile doğal diş görünümüne en yakın sonuçları elde ediyoruz. Zirkonyum kaplamalar, ışık geçirgenliği sayesinde mat ve yapay bir görünüm oluşturmaz; aksine dişlerinize canlı, doğal ve estetik bir beyazlık kazandırır. Kayseri’de zirkonyum diş yaptırmak isteyen hastalarımız için hem ön diş estetiğinde hem de arka dişlerde uzun ömürlü ve sağlam çözümler sunuyoruz.<div data-ast-id="f:/src/pages/ZirconiumCoating/sections/AboutMe.tsx|sig:4mvfmz" data-ast-start="3513" data-ast-end="3530"><br /></div><div data-ast-id="f:/src/pages/ZirconiumCoating/sections/AboutMe.tsx|sig:4mu7vz" data-ast-start="3530" data-ast-end="4157">&nbsp; Zirkonyum diş kaplama, özellikle kırık, aşınmış, renklenmiş veya formu bozulmuş dişlerde ideal bir tedavi seçeneğidir. Kayseri’de zirkonyum tedavisi süreci, detaylı muayene ve dijital analiz ile başlar, ardından dişlerinize en uygun form ve renk belirlenerek uygulama gerçekleştirilir. Metal altyapı içermediği için diş eti ile uyumu oldukça yüksektir ve zamanla diş eti kenarında koyu renk yansıması oluşturmaz. Kayseri zirkonyum diş fiyatları ise uygulanacak diş sayısı ve tedavi kapsamına göre değişiklik göstermektedir; en doğru planlama için kliniğimizde yapılacak değerlendirme sonrası net bilgi verilmektedir.</div></p>
              <p>&nbsp; Yüksek hijyen standartları ve hasta konforunu ön planda tutan yaklaşımımızla, her tedavi sürecini bir sanat eserine dönüştürüyoruz. Hollywood Smile'dan implant tedavilerine kadar geniş bir yelpazede, hayalinizdeki gülüşü gerçeğe dönüştürmek için profesyonel ekibimizle yanınızdayız.</p>
            </div>

            <div className="mt-10 flex flex-col sm:flex-row items-start sm:items-center gap-8">
              <Button asChild size="lg" className="bg-gradient-to-br from-[var(--primary)] to-[var(--chart-4)] text-primary-foreground hover:opacity-90 shadow-lg rounded-none px-8 transition-all duration-300">
                <Link to="/TransformationGalleryPage">
                  Değişim Galerisi
                  <ArrowRight className="ml-2 size-4" />
                </Link>
              </Button>
              
              <div className="font-serif text-2xl md:text-3xl text-foreground/80 italic tracking-widest">Dt.Ayşegül İnneci Uzun</div>
            </div>
          </div>

        </div>
      </div>
    </section>;
}